import { RIGHT_ALIGNED_LANGUAGES } from '../constants/languageConstants';

export const setDocumentDirection = (languageCode) => {
    const dir = RIGHT_ALIGNED_LANGUAGES.includes(languageCode) ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
};
